import HeroSection from "../../components/heroSection/HeroSection";

const LandingPage = () => {
    return (<>
        <HeroSection />
    </>);
}

export default LandingPage;